/* eslint-disable @typescript-eslint/no-magic-numbers */
import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { Stack } from '@cp/ds/src/components/stack';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Image } from '@cp/ds/src/components/image';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { ArrowRightIcon } from '@cp/ds/src/icons/arrowRight';
import { ImageAsset } from '@common/model/resource/image';
// eslint-disable-next-line import/no-duplicates
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { useCareerDeclination } from '@cp/entities/career';
// eslint-disable-next-line import/no-duplicates
import PaintedRedArrowImage1920 from '../../../../assets/images/paintedRedArrow.png';
// eslint-disable-next-line import/no-duplicates
import PaintedRedArrowImage1920Webp from '../../../../assets/images/paintedRedArrow.png?format=webp';
import { CatalogBannerSearchProps } from './model';

export * from './model';

const paitedRedArrowImageAsset: ImageAsset = {
  base: PaintedRedArrowImage1920,
  webp: PaintedRedArrowImage1920Webp,
};

const PAINTED_RED_ARROW_IMAGE_WIDTH_DESKTOP = 85;
const PAINTED_RED_ARROW_IMAGE_WIDTH_MOBILE = 100;

export const CatalogBannerSearch: React.FC<CatalogBannerSearchProps> = ({ itemType, careerId, careerDict, onClick, sx }) => {
  const isMobile = useIsMobile();
  const declination = useCareerDeclination();
  const isResumeCatalog = itemType === CatalogItemType.Resume;

  if (!careerDict) {
    return <ContentSkeleton blocks={1} />;
  }

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      sx={mergeSx(
        { p: isMobile ? 1.5 : 3, px: isMobile ? 1.5 : 3.75, backgroundColor: 'gray light', alignItems: isMobile ? 'stretch' : 'center' },
        sx,
      )}
    >
      <Box sx={{ position: 'relative', flex: '1 1 0px' }}>
        <Typography component="div" variant="h2">
          {!isResumeCatalog ? (
            <>В поисках подходящей{isMobile ? <br /> : ' '}вакансии?</>
          ) : (
            `В поисках ${careerDict[careerId]?.translation.nameSingleGenitive ?? 'специалиста'}?`
          )}
        </Typography>

        <Typography component="div" sx={{ mt: isMobile ? 1.5 : 2, pr: isMobile ? 10 : 0 }} variant="body">
          Разместите {!isResumeCatalog ? 'своё резюме' : 'свою вакансию'} уже сейчас.{isMobile ? ' ' : <br />}Это повысит ваши шансы найти{' '}
          {!isResumeCatalog ? 'хорошую работу' : 'хорошего специалиста'}.
        </Typography>

        <Image
          alt=""
          asset={paitedRedArrowImageAsset}
          sx={{
            width: isMobile ? PAINTED_RED_ARROW_IMAGE_WIDTH_MOBILE : PAINTED_RED_ARROW_IMAGE_WIDTH_DESKTOP,
            height: 'auto',
            position: 'absolute',
            right: isMobile ? 0 : 12,
            top: '50%',
            transform: isMobile ? 'translateY(-35%) rotateZ(-50deg) scaleX(-1)' : 'translateY(-50%)',
          }}
        />
      </Box>

      <Box sx={{ mt: isMobile ? 2.25 : 0 }}>
        <Button
          color="gray"
          iconRight={<ArrowRightIcon />}
          onClick={onClick}
          sx={{ width: isMobile ? 1 : undefined, backgroundColor: 'white', whiteSpace: 'nowrap' }}
          variant="secondary"
        >
          Разместить {!isResumeCatalog ? 'резюме' : 'вакансию'}
        </Button>
        <Typography component="div" sx={{ mt: isMobile ? 1 : 1.5, textAlign: 'center' }} variant="small text">
          Это бесплатно! Уже 12 359{' '}
          {!isResumeCatalog
            ? `${declination(12359, careerId)} нашли работу`
            : `семей нашли ${careerDict[careerId]?.translation.nameSingleAccusative ?? 'специалиста'}`}
        </Typography>
      </Box>
    </Stack>
  );
};
